import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DepartmentService } from 'src/app/services/department/department.service';

interface responseType {
  status: number;
  msg: string
  // Other properties in your response
}
@Component({
  selector: 'app-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.scss']
})
export class AddDepartmentComponent {
  public depForm!: FormGroup;
  public isSpinnerLoading: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    public dialogRef: MatDialogRef<AddDepartmentComponent>,
    private departmentService: DepartmentService,
    private commonService: CommonService
  ) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.depForm = this.fb.group({
      dep: ["",],

    })
    if (this.dialogData.edit == true) {
      this.depForm.get('dep')?.setValue(this.dialogData.editData.dep)
    }
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.depForm, controlName, validationType);
  }
  onCancel() { }
  onSubmit() {
    this.isSpinnerLoading = true;
    if (this.depForm.invalid) {
      this.depForm.markAllAsTouched()
    }
    else {
      if(this.dialogData.edit==true){
        this.onEditSubmit()
      }
      else{
        this.onAddSubmit()
      }
    }
  }
  onAddSubmit(){
    this.departmentService.add(this.depForm.value).subscribe({
      next: (response: any) => {
        this.isSpinnerLoading = false;
        if (response.status === 200) {
          this.appService.showToastMessage("success", response.msg)
          this.dialogRef.close({ data_added: true })
        }
      },
      error: (error) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      }
    });
  }
  onEditSubmit() {
      let obj = {
        "dep": this.depForm.get("dep")?.value,
        "cd_i": this.dialogData.editData.cd_i
      }
      this.departmentService.edit(obj).subscribe({
        next: (response: any) => {
          this.isSpinnerLoading = false;
          if (response.status === 200) {
            this.appService.showToastMessage("success", response.msg)
            this.dialogRef.close({ data_added: true })
          }
        },
        error: (error) => {
          this.isSpinnerLoading = false;
          this.commonService.handleError(error);
        }
      });
    
  }
}
